/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_From_LabelInputs */



/**
* | output |
* | --- |
* | "From" |
*
* @param {Event_Group_Sync_From_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_from_label = /** @type {((inputs?: Event_Group_Sync_From_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_From_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("From")
	if (locale === "de") return /** @type {LocalizedString} */ ("From")
	if (locale === "it") return /** @type {LocalizedString} */ ("From")
	if (locale === "ru") return /** @type {LocalizedString} */ ("From")
	if (locale === "es") return /** @type {LocalizedString} */ ("From")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("From")
	if (locale === "ja") return /** @type {LocalizedString} */ ("From")
	if (locale === "hi") return /** @type {LocalizedString} */ ("From")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("From")
	return /** @type {LocalizedString} */ ("From")
});